import { ButtonBase, Link, alpha, styled } from '@mui/material'

interface ButtonBaseLinkProps {
  href?: string
  disableRipple?: boolean
}

export const LogoLinkWrapper = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  border: 'solid',
  borderRadius: '2px',
  borderColor: 'transparent',
  borderWidth: '1px',

  '&:focus': {
    outline: 'none',
    borderColor: theme.palette.primary?.main,

    '&:not(:focus-visible)': {
      borderColor: 'transparent',
    },
  },
}))

export const StyledSecondaryActionButton = styled(ButtonBase, {
  shouldForwardProp: (props: string) =>
    !['isMobile', 'compact', 'withBorder'].includes(props),
})<ButtonBaseLinkProps & { compact?: boolean; withBorder?: boolean }>(
  ({ theme, compact, withBorder }) => ({
    ...theme.typography.body1,
    display: 'flex',
    gap: 6,
    margin: 0,
    color: theme.palette.text.primary,
    textDecoration: 'none',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 24,
    transition: theme.transitions.create(['color', 'background-color']),

    '&:focus-visible': {
      outline: 'none',
      color: theme.palette.text?.primary,
      backgroundColor: alpha(theme.palette.primary?.main, 0.3),
    },
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary?.main, 0.04),
      color: theme.palette.primary?.main,
    },

    ...(withBorder && {
      border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`,
      borderRadius: '24px',

      '&:hover': {
        backgroundColor: theme.palette.action?.hover,
      },
      '&:focus-visible': {
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.action?.focus,
      },
    }),

    ...(compact && {
      aspectRatio: '1 / 1',
      borderRadius: '50%',
      padding: 0,
      height: 42,
      width: 42,

      [theme.breakpoints.up('lg')]: {
        height: 48,
        width: 48,
      },
    }),

    ...(!compact && {
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        justifyContent: 'flex-start',
        padding: `${theme.spacing(1, 1)}`,
        borderRadius: 0,
      },
    }),
  })
)
